import React, { PropTypes } from 'react';
import { factoryCmsContent } from '../../../api/club-cms/content';
import { CMSContentType } from '../../../api/club-cms/CMSType';
import { SimpleButton } from '../../common/SimpleButton';

export class AddContentToolbar extends React.Component {
  static propTypes = {
    onAdd: PropTypes.func.isRequired
  };

  addItem(type) {
    const { onAdd } = this.props;
    onAdd(factoryCmsContent(type));
  }

  render() {
    const buttonProps = {
      secondary: true,
      style: {
        padding: '0 10px'
      },
      labelStyle: {
        // lineHeight: 2.8,
        padding: 0,
        fontSize: 16,
        textTransform: 'none'
      }
    };
    const containerStyle = {
      position: 'sticky',
      top: 135,
      marginLeft: -30,
      display: 'flex',
      padding: '0 30px',
      margin: '30px 0',
      backgroundColor: 'white',
      boxShadow: '1px 1px 3px rgb(0 0 0 / 20%)'
    }
    return (
      <div style={ containerStyle }>
        <SimpleButton
          label="Add Gallery"
          onClick={() => this.addItem(CMSContentType.gallery)}
          {...buttonProps}
        />
        {/* <br /><SimpleButton
          label="Add Transfers"
          onClick={() => this.addItem(CMSContentType.transfers)}
          {...buttonProps}
        /> */}
        <br />
        <SimpleButton
          label="Add Text"
          onClick={() => this.addItem(CMSContentType.richText)}
          {...buttonProps}
        />
        <br />
        <SimpleButton
          label="Add Map"
          onClick={() => this.addItem(CMSContentType.map)}
          {...buttonProps}
        />
      </div>
    );
  }
}

export default AddContentToolbar;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/AddContentToolbar.js